import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  principalList01ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  principalList01GoToResource: ['resId'],
  principalList01NewResource: null,
  principalList01FetchPrincipalList01: ['currentPage', 'sorts', 'filters', 'pageSize'],
  principalList01FetchPrincipalList01Loading: ['boolean'],
  principalList01FetchPrincipalList01Success: [
    'resources',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  principalList01AddSelectedResources: ['selectedResources'],
  principalList01RemoveSelectedResources: ['selectedResources'],
  principalList01SetWorkspaceVisible: ['boolean']
});

export const PrincipalList01Types = Types;
export default Creators;
